<template>
  <v-field :label='label' :error='errors.first(name)' :tooltip='tooltipMsg'>
    <input :disabled="$can.not('edit-exploitation')" v-bind='$attrs' :value='value' type='text' @input='$emit("input", $event.target.value)' >
  </v-field>
</template>

<script>
import mixinTooltip from '@/mixins/tooltip'

export default {
  name: 'FieldText',

  inheritAttrs: false,
  inject: ['$validator'],
  mixins: [mixinTooltip],

  props: {
    value: String,
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: 'notDefined'
    }
  }
}
</script>
